import { atom } from "jotai";

export type PlusPopupState = {
  fromDrawerUrl?: string;
  isShowArticlePopup: boolean;
  isShowBlurbPopup: boolean;
  isShowDetailListingPopup: boolean;
  originalUrl?: string;
};

export const plusPopupAtom = atom<PlusPopupState>({
  isShowArticlePopup: false,
  isShowBlurbPopup: false,
  isShowDetailListingPopup: false,
});
